<template>
  <div class="warp">
    <div class="warp-content">
      <div class="title">发布站内短信</div>
      <div class="form-content">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="场地列表" prop="rentalAreasId">
            <div style="width: 100%;height: 250px;">
              <nk-table :columns="columns" :data="tableData" :selectColumnVisible="true" @handleSelectionChange="handleSelectionChange"></nk-table>
            </div>
          </el-form-item>
          <el-form-item label="标题" prop="title">
            <el-input v-model="ruleForm.title"></el-input>
          </el-form-item>
          <el-form-item label="消息内容" prop="message">
            <el-input type="textarea" v-model="ruleForm.message"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm()">发布</el-button>
            <el-button @click="resetForm()">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import NkTable from '@/components/common/NkTable.vue'
import tmp from '@common/utils/tmp.js'
import api from '../../../../../common/api';
export default {
  components: { NkTable },
  data () {
    var checkArray = (rule, value, callback) => {
      if (value && value.length === 0) {
        return callback(new Error('请至少选择一个场地'));
      }
      callback();
    }
    return {
      columns: [
        { prop: "name", label: "名称", show: true },
        { prop: "place", label: "位置", show: true },
        { prop: "area", label: "面积", show: true }
      ],
      tableData: [],
      ruleForm: {
      },
      rules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ],
        message: [
          { required: true, message: '请输入消息内容', trigger: 'blur' }
        ],
        rentalAreasId: [
          { validator: checkArray, trigger: 'change' }
        ],
      }
    };
  },
  created () {
    this.getData()
  },
  methods: {
    getData () {
      tmp.getAreaDataInHosting().then(res => {
        let tableData = []
        if (res.data) {
          tableData = res.data
        }
        this.tableData = tableData
      })
    },
    handleSelectionChange (data) {
      let rentalAreasId = []
      for (let i = 0; i < data.length; i++) {
        const element = data[i];
        rentalAreasId.push(element.id)
      }
      this.ruleForm.rentalAreasId = rentalAreasId
    },
    submitForm () {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          const { title, message, rentalAreasId } = this.ruleForm
          api.notifyMsg.pushNotifyMsgToMyProperties(rentalAreasId, title, message).then(res => {
            if (res.success) {
              this.$message(res.errorStr)
            }
          })
        }
      });
    },
    resetForm () {
      this.$refs['ruleForm'].resetFields();
    }
  }
}
</script>

<style lang="scss" scoped>
.warp {
  width: 100%;
  height: 100%;
  padding: 14px;
  box-sizing: border-box;
  text-align: left;
  color: #606266;
  .warp-content {
    width: 100%;
    height: 100%;
    padding: 10px;
    box-sizing: border-box;
    background: #fff;
    display: flex;
    flex-flow: column;
    .title {
      font-size: 18px;
      height: 40px;
      line-height: 40px;
      border-bottom: 1px solid #dcdfe6;
      flex: 0 0 40px;
    }
    .form-content {
      flex: 1;
      margin-top: 10px;
      overflow: auto;
      .demo-ruleForm {
        width: 600px;
      }
    }
  }
}
</style>